/**
 * GatewayHomeButton — Super Admin portal ONLY.
 *
 * Locked 2026-05-31 (revised per owner directive):
 *   "There should never be a gateway home button on any page but the
 *    super admin portal."
 *
 * This button is now rendered ONLY on `/super-admin/*` routes (including
 * the SA login). Every other page uses the corner-mounted view-mode
 * toggle instead, which sits in the same top-left slot.
 */
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Home } from 'lucide-react';

const GatewayHomeButton = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // SUPER ADMIN portal ONLY (including /super-admin/login).
  const isSuperAdmin = location.pathname.startsWith('/super-admin');
  if (!isSuperAdmin) return null;

  return (
    <button
      type="button"
      onClick={() => navigate('/')}
      data-testid="gateway-home-button"
      aria-label="Back to RemodDash Gateway"
      className="hidden sm:inline-flex fixed top-2 left-3 z-[5000] items-center gap-1.5 px-3 py-1.5 rounded-full bg-white/95 backdrop-blur-sm border border-slate-200 shadow-sm text-xs font-semibold text-slate-700 hover:bg-white hover:text-slate-900 transition-colors"
      style={{ pointerEvents: 'auto' }}
    >
      <Home className="w-3.5 h-3.5" />
      Gateway
    </button>
  );
};

export default GatewayHomeButton;
